import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Box from '@material-ui/core/Box';
import { SERVICE_TYPE_FILTERS_EXCLUDING_LEGAL } from '../../constants/elevation';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    dropdown: {
    },
}));


const ServiceTypeSelector = ({ selectedServiceType, handleServiceTypeChange }) => {
    const classes = useStyles()

    return (
        <Box>
            <Select
                className={classes.dropdown}
                variant="outlined"
                value={selectedServiceType}
                onChange={handleServiceTypeChange}
            >
                {SERVICE_TYPE_FILTERS_EXCLUDING_LEGAL.map(serviceType => (
                    <MenuItem
                        key={`service-type-item-${serviceType.type}`}
                        value={serviceType.type}
                    >
                        {serviceType.name}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    )
}

export default ServiceTypeSelector
